import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { EntityLink } from "scmp-app/components/entity-link";
import { useSearchContext } from "scmp-app/components/search/contexts";
import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";
import type { SearchEvent } from "scmp-app/components/tracking/google-analytics-4/types";
import type { topicSearchResultListItemTopic$key } from "scmp-app/queries/__generated__/topicSearchResultListItemTopic.graphql";

import { Container, TitleContainer, TopicTitle } from "./styles";

export type Props = {
  reference: topicSearchResultListItemTopic$key;
};

export const TopicSearchResultListItem: FunctionComponent<Props> = ({
  reference: reference_,
  ...props
}) => {
  const topic = useFragment<topicSearchResultListItemTopic$key>(
    graphql`
      fragment topicSearchResultListItemTopic on Topic {
        entityId
        name
        ...entityLink
      }
    `,
    reference_,
  );

  const { currentValue } = useSearchContext();

  const handleTopicClick = () => {
    // GA4 21.2.1
    sendGA4Tracking({
      action: "click",
      category: "search",
      customized_parameters: {
        search_text: currentValue,
        topic_id: topic?.entityId,
      },
      subcategory: "result",
    } as SearchEvent);
  };

  return (
    <Container {...props}>
      <EntityLink onClick={handleTopicClick} reference={topic}>
        <TitleContainer>
          <TopicTitle>{topic.name}</TopicTitle>
        </TitleContainer>
      </EntityLink>
    </Container>
  );
};

TopicSearchResultListItem.displayName = "TopicSearchResultListItem";
